"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneyToJSON = exports.MoneyFromJSONTyped = exports.MoneyFromJSON = exports.instanceOfMoney = void 0;
/**
 * Check if a given object implements the Money interface.
 */
function instanceOfMoney(value) {
    var isInstance = true;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "units" in value;
    isInstance = isInstance && "nanos" in value;
    return isInstance;
}
exports.instanceOfMoney = instanceOfMoney;
function MoneyFromJSON(json) {
    return MoneyFromJSONTyped(json, false);
}
exports.MoneyFromJSON = MoneyFromJSON;
function MoneyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currencyCode': json['currencyCode'],
        'units': json['units'],
        'nanos': json['nanos'],
    };
}
exports.MoneyFromJSONTyped = MoneyFromJSONTyped;
function MoneyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currencyCode': value.currencyCode,
        'units': value.units,
        'nanos': value.nanos,
    };
}
exports.MoneyToJSON = MoneyToJSON;
